var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrevious(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 473.654 473.654",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#0B7077"
    },
    cx: 236.827,
    cy: 236.827,
    r: 236.827
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M404.764,207.969c-83.101,0-166.202,0-249.302,0c-0.673,0-1.313,0.06-1.96,0.094 c30.582-28.469,61.161-56.943,91.743-85.416c26.484-24.655-13.425-64.089-39.883-39.46c-47.657,44.37-95.318,88.74-142.975,133.114 c-10.938,10.187-10.635,29.569,0.213,39.669c47.657,44.366,95.314,88.736,142.971,133.103c26.405,24.58,66.015-15.156,39.46-39.883 c-30.504-28.398-61.007-56.793-91.511-85.191c0.512,0.022,1.006,0.075,1.533,0.075c83.101,0,166.202,0,249.302,0 C440.582,264.077,440.899,207.969,404.764,207.969z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevious);
export default __webpack_public_path__ + "static/media/previous.a30c2a82f8a7657e94a2dddf0766114a.svg";
export { ForwardRef as ReactComponent };